module.exports = __webpack_public_path__ + "img/banner_aovivo.fbe82d1d.png";